import React from 'react';

import Icon from './';

export default Icon(() => (
    <path d="M17.8,7.5l2.6-2.6l-1.3-1.3l-3,3C14.9,6,13.6,5.6,12,5.6C5.7,5.6,2,11.8,2,11.8s1.6,2.6,4.5,4.5l-2.8,2.8l1.3,1.3l3.2-3.2 C9.3,17.6,10.6,18,12,18c6.2,0,9.9-6.2,9.9-6.2S20.5,9.3,17.8,7.5z M7.6,11.8c0-2.4,1.9-4.3,4.4-4.3c0.9,0,1.8,0.3,2.5,0.8l-1.8,1.8 c0-0.2,0.1-0.4,0.3-0.6c-0.3-0.1-0.7-0.2-1-0.2v0h0c-1.4,0-2.5,1.1-2.5,2.5c0,0.4,0.1,0.8,0.3,1.1l-1.4,1.4 C7.9,13.6,7.6,12.7,7.6,11.8z M12,16.1c-0.8,0-1.5-0.2-2.2-0.6l1.4-1.4c0.3,0.1,0.5,0.1,0.8,0.1c1.4,0,2.5-1.1,2.5-2.5 c0-0.3-0.1-0.6-0.1-0.8l1.4-1.4c0.4,0.6,0.6,1.4,0.6,2.2C16.3,14.2,14.4,16.1,12,16.1z" />
));
